import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/helpers/composables/useI18n';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed } from 'vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { BuyBoxFilterOptions } from '@/stores/user.store';
import { jwCheckIcon } from '@/plugins/global-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoOffers',
  props: {
    isTitleInWatchlist: { type: Boolean, default: false },
    title: null,
    filter: null,
    additionalContexts: { default: () => [] },
    showSubtitle: { type: Boolean, default: true }
  },
  emits: ["onNotifyMe"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'onNotifyMe'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isTitleInWatchlist: boolean, title: TitleDetail, filter: BuyBoxFilterOptions, additionalContexts: SnowplowContext[], showSubtitle: boolean };

const BasicButton = () => import('@/ui-components/BasicButton.vue');

const { t, tc } = useI18n();





const onNotifyMe = () => {
	emit('onNotifyMe');

	let offerType = '';
	switch (props.filter) {
		case 'free':
			offerType = 'free';
			break;
		case 'cinema':
			offerType = 'cinema';
			break;
		default:
			offerType = 'streaming';
			break;
	}

	TrackingHelper.trackEvent('userinteraction', {
		action: 'notify_me_clicked',
		label: offerType,
		value: !props.isTitleInWatchlist ? 1 : 0,
	});
};

const titleName = computed(() => props.title.content.title);

return { __sfc: true,BasicButton, t, tc, props, emit, onNotifyMe, titleName, jwCheckIcon, faBell }
}

})